import { apiRequest, buildQuery } from './client';

// Also update local badges if the WebSocket is temporarily disconnected.
const mutate = async request => {
  const result = await request;
  window.dispatchEvent(new Event('amposter:notification-counts-changed'));
  return result;
};

export const notificationsApi = {
  list: (options) => apiRequest(`/api/v1/me/notifications${buildQuery(options)}`),
  unreadCount: () => apiRequest('/api/v1/me/notifications/unread-count'),
  unreadBuckets: () => apiRequest('/api/v1/me/notifications/unread-buckets'),
  read: (id) => mutate(apiRequest(`/api/v1/me/notifications/${id}/read`, { method: 'PUT' })),
  unread: (id) => mutate(apiRequest(`/api/v1/me/notifications/${id}/read`, { method: 'DELETE' })),
  readAll: (options = {}) => mutate(apiRequest(`/api/v1/me/notifications/read-all${buildQuery(options)}`, { method: 'POST' })),
  removeAll: (options) => mutate(apiRequest(`/api/v1/me/notifications${buildQuery(options)}`, { method: 'DELETE' })),
  remove: (id) => mutate(apiRequest(`/api/v1/me/notifications/${id}`, { method: 'DELETE' })),
  registerDevice: (body) => apiRequest('/api/v1/me/push-devices', { method: 'POST', body }),
  devices: () => apiRequest('/api/v1/me/push-devices'),
  setDeviceNotifications: (id, enabled) => apiRequest(`/api/v1/me/push-devices/${id}/notifications`, { method: 'PUT', body: { enabled } }),
  removeDevice: (id) => apiRequest(`/api/v1/me/push-devices/${id}`, { method: 'DELETE' }),
};
